import * as React from 'react'
import { inject } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { ITermMonthScore } from '../../../Model/Questionnaire'

export interface ITermMonthScoreViewProps {
    term: ITermMonthScore
    className?: string
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
export default class TermMonthScoreView extends React.Component<ITermMonthScoreViewProps> {
    render() {
        const { className, term, localizationStore } = this.props
        return (
            <div className={className}>
                <p>{term.Duration} {localizationStore!.t!('months')}: {Math.round(term.Score * 100)} %</p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Score/TermMonthScoreView.tsx